import { render, staticRenderFns } from "./iconChart.vue?vue&type=template&id=367c1d7b"
import script from "./iconChart.vue?vue&type=script&lang=js"
export * from "./iconChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports